import DataStatus from 'src/app/shared/models/datastatus.class';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, signal } from '@angular/core';
import AzureService from 'src/app/shared/services/azure.service';
import { Subscription } from 'rxjs';
import { IAzureWebApp } from 'src/app/shared/interfaces/azure/webapp.interface';
import { MatDialog } from '@angular/material/dialog';
import { AppSettingsFormComponent } from 'src/app/shared/components/app-settings-form/app-settings-form.component';
import AzureDevopsService from 'src/app/shared/services/azuredevops.service';

@Component({
  standalone: false,
  selector: 'app-webapps-with-pulumi',
  templateUrl: './webapps-with-pulumi.component.html',
  styleUrls: ['./webapps-with-pulumi.component.css'],
})
export class WebappsWithPulumiComponent implements OnInit {
  constructor(
    private azureService: AzureService,
    private azureDevopsService: AzureDevopsService,
    private activatedRoute: ActivatedRoute,
    private modalService: MatDialog,
    private router: Router
  ) {}

  public pullRequestsTitle: Array<string> = [];
  public readonly webAppsWithPulumi = signal<IAzureWebApp[]>([]);
  public dataStatus = new DataStatus();
  public readonly repositoryName = signal('');
  public repositoryId!: string;
  public webAppsWithPulumiSubscription!: Subscription;
  public searchBarContent: string = '';
  
  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe({
      next: (params) => {        
        if (params['appSettingsModal']) {
          this.openAppSettingsModal(params['appSettingsModal']);
        }
      }
    })

    this.activatedRoute.params.subscribe({
      next: (params) => {        
        if (this.webAppsWithPulumiSubscription)
          this.webAppsWithPulumiSubscription.unsubscribe();

        this.dataStatus.loading.set(true);
        this.webAppsWithPulumi.set([]);
        this.repositoryName.set(params['repositoryName']);

        this.azureDevopsService.getRepositories().subscribe({
          next: (repos) => {

            const repo = repos.find(r => r.name === this.repositoryName());

            if (repo) {
              this.webAppsWithPulumiSubscription = this.azureService
              .getWebAppsWithPulumi(this.repositoryName(), repo.id!)
              .subscribe({
                next: (webapps) => {
                  if (webapps.length === 0) {
                    this.dataStatus.empty.set(true);
                    this.dataStatus.loading.set(false);
                    return;
                  }
                  this.webAppsWithPulumi.set(webapps);                  
                  this.dataStatus.loading.set(false);
                  this.dataStatus.completed.set(true);
                  this.dataStatus.empty.set(false);
                },
              });
            }

          }
        })
        
        
      },
    });
  }

  public openAppSettingsModal(webAppName: string) {    
    this.modalService.open(AppSettingsFormComponent, {
      height: "100vh",
      width: "50%",
      position: {
        right: '0px'
      },
      data: {
        webAppName
      }
    }).afterClosed().subscribe({
      next: () => {
        this.router.navigate(['.'], { relativeTo: this.activatedRoute });
      }
    });   
  }

  public extractPullRequestId(webappName: string): number {
    return Number(webappName.split('-')[1]);
  }
}
